import { render, staticRenderFns } from "./DotOutput.vue?vue&type=template&id=c0370002&scoped=true"
import script from "./DotOutput.vue?vue&type=script&lang=js"
export * from "./DotOutput.vue?vue&type=script&lang=js"
import style0 from "./DotOutput.vue?vue&type=style&index=0&id=c0370002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0370002",
  null
  
)

export default component.exports